module.exports = __webpack_public_path__ + "static/media/privacy.bc3777c0.svg";